





















































import {
  CalculatorBasicFieldDcl,
  CalculatorResource
} from '@ligo/bv-flow/store';
import { Dictionary, strictTrue } from '@ligo/shared/utils';
import { defineComponent, ref } from '@vue/composition-api';
import { PropType } from 'vue';
import CalculatorQuestionsCard from '../CalculatorQuestionsCard.vue';
import { BvLayoutPageInformation } from '@ligo/bv-flow/hooks';

export default defineComponent({
  name: 'QuestionCardForSpeed',
  components: { CalculatorQuestionsCard },
  props: {
    cardClass: {
      type: String,
      default: 'col-12'
    },
    contentClass: {
      type: String,
      default: 'full-width row q-pa-md'
    },
    flat: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'white'
    },
    active: {
      type: Boolean,
      default: true
    },
    fieldKey: String,
    field: {
      type: Object as PropType<CalculatorBasicFieldDcl<any>>,
      required: true
    },
    calculator: {
      type: Object as PropType<CalculatorResource>
    },
    loading: Boolean
  },
  setup(props, { emit }) {
    const questionsCard = ref(null as any);
    const internalLoading = ref(props.loading);
    const enabled = ref(false);

    const { load: loadPageInformation, t, isReady } = BvLayoutPageInformation;

    (async function load() {
      if (!isReady()) {
        await loadPageInformation();
      }
      if (strictTrue(t('incorporation_speed.enabled'))) {
        enabled.value = true;
      }
      internalLoading.value = false;
    })();

    function onAnswer(args: Dictionary, key: string) {
      emit('on-answer', args, key);
    }

    function getOptions() {
      return [
        { value: 'medium', label: t('incorporation_speed.medium') },
        { value: 'slow', label: t('incorporation_speed.slow') }
      ];
    }

    return {
      internalLoading,
      enabled,
      onAnswer,
      getOptions,
      t,
      questionsCard
    };
  }
});
